import { createResourceCollection } from '@/request'
import { EligibleMake } from '@/types/vehicle'

export const eligibleMakesCollection = createResourceCollection<EligibleMake>({
  name: 'eligibleMakes',
  apiConfig: {
    path: 'eligible-makes',
  },
  selector: (state) => state.eligibleMakes,
})

export const eligibleMakesCollectionReducer =
  eligibleMakesCollection.slice.reducer
